// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VTooltip from 'v-tooltip'
import './styles/index.less'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)
//合作伙伴页面使用了area插件
// import 'vue-area-linkage/dist/index.css';
// import VueAreaLinkage from 'vue-area-linkage';
// Vue.use(VueAreaLinkage)
import axios from 'axios'
Vue.prototype.$ajax = axios
Vue.config.productionTip = false
import animated from 'animate.css' // npm install animate.css --save安装，再引入
Vue.use(animated)
Vue.use(VTooltip)

    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js